import type React from "react"
import type { CobaltButtonElement } from "../Buttons/Button"
import ButtonsGroup from "../Buttons/ButtonsGroup"

export interface EmptyStateProps {
  children?: React.ReactNode
  title: string
  action?: CobaltButtonElement
  secondaryAction?: CobaltButtonElement
  image: string
}

export const EmptyState = ({
  title,
  children,
  action,
  secondaryAction,
  image,
}: EmptyStateProps) => {
  return (
    <div className="cobalt-EmptyState">
      <img
        className="cobalt-EmptyState__Image"
        alt=""
        src={image}
        height={188}
        width={188}
      />
      <h2 className="cobalt-EmptyState__Title">{title}</h2>
      {children && <div className="cobalt-EmptyState__Body">{children}</div>}
      {action && (
        <ButtonsGroup align="center">
          {action}
          {secondaryAction}
        </ButtonsGroup>
      )}
    </div>
  )
}
